export default __webpack_public_path__ + "static/media/manage_employers_challenges.28a25bb5.svg";